export const isNotNullish = <T>(
  data: T
): data is Exclude<T, undefined | null> => {
  return data !== null && data !== undefined;
};
